import {LanguageInputsSwitcher} from "../../admin/utils/LanguageInputsSwitcher";
import {getPrimaryLanguage} from "../../utils/localization";


/**
 * @deprecated
 */
export class OptionLanguageInputSwitcher extends LanguageInputsSwitcher
{
    constructor()
    {
        super();
    }

    /**
     * Build an array of translations and values.
     *
     * @param $node
     * @param selector
     * @return {{}}
     */
    static getValue($node, selector)
    {
        const $nodes = $node.find(selector);
        let values = {};

        $nodes.each(function(){
            const $input = $(this);
            const language = $input.data('language');
            values[language] = $input.val();
        })

        return values;
    }

    static setValue($node, value)
    {
        const $wrapper = $node.closest('.form-group__top');
        // @todo: refactor
        if(value[getPrimaryLanguage] !== undefined) {
            $wrapper.find('.form-field__input.de').val(value[getPrimaryLanguage()]);
        } else {
            $wrapper.find('.form-field__input.de').val(value);
        }
    }

    static getString(values)
    {
        return values[getPrimaryLanguage()];
    }
}